import ActionsMenu from "../../../../../components/action-buttons/ActionsMenu";
import {GeneralInfoTreeChildrenProps} from "../../../types";
import {ArrowRightOutlined, FileTextOutlined, LinkOutlined} from "@ant-design/icons";
import React from "react";
import {FinalGeneralInfoItem} from "../../../../../types/generalInfo";
import {useNavigate} from "react-router-dom";
import {useAuth} from "../../../../../context/authContext";
import "./style.less"


const GeneralInfoTreeChildren = (props: GeneralInfoTreeChildrenProps) => {

  const {item, generalInfoController} = props
  const {editButtonHandler, confirmDelete} = generalInfoController
  const {canManageContent} = useAuth()
  const navigate = useNavigate()
  const navigateToLink = (item: FinalGeneralInfoItem ) => {
    const {$id, isFileLink, link} = item
    if ($id) {
      if(isFileLink){
        navigate(`/general-info/${item.$id}`)
      }else {
        window.open(link, "_blank")
      }

    }
  }

  return <article className="general-information-item">
    <button className="general-information-item__main" type="button" onClick={() => navigateToLink(item)}>
      <span className="general-information-item__icon">
        {item.isFileLink ? <FileTextOutlined/> : <LinkOutlined/>}
      </span>
      <span className="general-information-item__content">
        <span className="general-information-item__type">
          {item.isFileLink ? "Документ" : "Зовнішній ресурс"}
        </span>
        <span className="general-information-item__title">{item.title}</span>
      </span>
      <ArrowRightOutlined className="general-information-item__arrow"/>
    </button>

    {canManageContent && <div className="general-information-item__actions">
      <ActionsMenu onEdit={() => editButtonHandler(item)} onDelete={() => item.$id && confirmDelete({id: item.$id})}/>
    </div>}
  </article>
}

export default GeneralInfoTreeChildren
